export default __webpack_public_path__ + "static/media/photo_right_4.7809fdd4.png";